import {ControllerParams} from '@wix/yoshi-flow-editor';
import {IWidgetController} from '@wix/native-components-infra/dist/src/types/types';
import {ControllerConstructorType} from '../../types/app.types';
import {SideCartController} from './SideCartController';

export const controllerFactory =
  <T extends SideCartController>(ControllerConstructor: ControllerConstructorType<T>) =>
  (controllerParams: ControllerParams): IWidgetController => {
    const siteStore = controllerParams?.appData?.context.siteStore;
    let controller: T | undefined;

    return {
      async pageReady() {
        try {
          await siteStore.loadClientConfig();
          controller = new ControllerConstructor(controllerParams);

          await controller.init();
          controllerParams.controllerConfig.wixCodeApi.location.onChange(() => void controller.load());
        } catch (error) {
          console.error(error);
          controllerParams.controllerConfig.setProps({generalError: true});
          controllerParams.appData.reportError(error);
        }
      },
      updateConfig: (_$w, updatedConfig: {[key: string]: any}): void => {
        return void controller.onStyleUpdate?.(updatedConfig.style.styleParams);
      },
    };
  };
